import {useState, useEffect, useCallback, Fragment} from 'react';
import { Trans } from '@common/i18n/trans';
import { useSettings } from '@common/core/settings/use-settings';
import { Button } from '@common/ui/buttons/button';
import { Dialog } from '@common/ui/overlays/dialog/dialog';
import { DialogHeader } from '@common/ui/overlays/dialog/dialog-header';
import { DialogBody } from '@common/ui/overlays/dialog/dialog-body';
import { DialogFooter } from '@common/ui/overlays/dialog/dialog-footer';
import { useDialogContext } from '@common/ui/overlays/dialog/dialog-context';
import { useForm, useFormContext } from 'react-hook-form';
import {FileWithPath, useDropzone} from 'react-dropzone';
import { Form } from '@common/ui/forms/form';
import { formatBytes } from '@common/utils/number/byte-format';
import { UwFilePayload, useAppendFileItem } from './requests/use-append-source';
import { UwSourceFile } from './uw-source-upload-add';

export function AppendSourceDialog({report_id, appendFiles}: {report_id: number|string, appendFiles: any}) {
  const form = useForm<UwFilePayload>({
  });
  const {formId, close} = useDialogContext();
  const [files, setFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles: any) => {
   setFiles(acceptedFiles);
	}, []);


  useEffect(() => {
    form.setValue('files', files);
}, [form, files]);
  
  const appendFileItem = useAppendFileItem(report_id, form);

  return (
    <Dialog size='800px'>
      <DialogHeader>
        <Trans message="Append Sources" />
      </DialogHeader>
      <DialogBody>
        <Form
            id={formId}
            form={form}
            onSubmit={value => {
              appendFileItem.mutate(value, {
                onSuccess: (e: any) => {
                  appendFiles(e.file_items);
                  close();
                },
              });
              
            }}
          >
          <UwSourceFile onDrop={onDrop}/>
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button
          variant="flat"
          color="orange"
          type="submit"
          form={formId}
          disabled={appendFiles.isPending}
        >
          <Trans message="Append Documents" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}

